<template>
  <div class="express-pay">
      <div class="app-header center">
        <h1>{{ title }}</h1>
      </div>
      <router-view />
  </div>
</template>

<script>
export default {
  name: 'ExpressPay',
  data() {
    return {
      title: 'Express Pay'
    }
  }
}
</script>

<style lang="scss" scoped>
.app-header {
  padding: 40px 0;
}
</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/ExpressPay.vue